import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [status, setStatus] = useState("verifying"); // verifying, success, error

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setStatus("success");
      } catch {
        setStatus("error");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-8" data-testid="verify-email-page">
      <div className="w-full max-w-sm text-center">
        <div className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-md bg-white border border-[#E6E6E6] flex items-center justify-center p-1">
            <img src="/logo.png" alt="SportsUnity" className="w-full h-full object-contain" />
          </div>
          <span className="text-lg font-semibold text-[#074572]" style={{ fontFamily: 'Outfit' }}>SportsUnity</span>
        </div>

        {status === "verifying" && (
          <div>
            <div className="w-8 h-8 border-2 border-[#074572] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-zinc-500">Verifying your email...</p>
          </div>
        )}
        {status === "success" && (
          <div>
            <div className="w-14 h-14 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check size={24} className="text-green-600" />
            </div>
            <h1 className="text-2xl font-medium text-zinc-900 mb-2" style={{ fontFamily: 'Outfit' }}>Email Verified!</h1>
            <p className="text-sm text-zinc-500 mb-6">Your email has been verified. You're all set.</p>
            <Link to="/feed"><Button className="bg-[#F85037] hover:bg-[#e04530] text-white">Go to Feed</Button></Link>
          </div>
        )}
        {status === "error" && (
          <div>
            <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <X size={24} className="text-red-600" />
            </div>
            <h1 className="text-2xl font-medium text-zinc-900 mb-2" style={{ fontFamily: 'Outfit' }}>Verification Failed</h1>
            <p className="text-sm text-zinc-500 mb-6">The link is invalid or has expired.</p>
            <Link to="/login"><Button variant="outline" className="border-[#E6E6E6] text-[#074572]">Go to Login</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
